module.exports = __webpack_public_path__ + "static/media/user4.206bdb2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svod/user4.png
// module id = 251
// module chunks = 0